import { useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { CreateForm } from "./CreateForm";

import { useNavigate } from "react-router-dom";

import { AdminAlbumService } from "../service";

export const CreateAlbum = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [triggerUpdate, setTriggerUpdate] = useState(false);
  const [state, setState] = useState<any>({ isActive: true });

  const submitHandler = () => {
    AdminAlbumService.create(state)
      .then((response) => {
        SuccessToast(t(`album.successfully_created`));
        setTriggerUpdate(!triggerUpdate);
        setState({});
        navigate("/admin/album");
      })
      .catch((error) => ErrorToast(error));
  };

  return (
    <div className="col-12">
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          submitHandler();
        }}
      >
        <CreateForm state={state} setState={setState} />
      </Form>
    </div>
  );
};
